<div class="header">
    <img [class]="companyImage === '../../assets/img/1-ez-docs-white.png' ? 'company-img ez-docs' : 'company-img '" src="{{ companyImage }}" alt="ddj logo" [routerLink]="['login']" />
    <img
        [class]="productImage === '../../assets/img/ez-docs-logo-white.png' ? 'product-img ez-docs' : 'product-img'"
        src="{{ productImage }}"
        alt="unite digital logo"
    />
</div>
